import {
  Archive,
  ArrowLeft,
  CheckCircle2,
  Home,
  Languages,
  MicVocal,
  X,
} from "lucide-react";

type NavigationBaseProps = {
  ariaLabel: string;
};

export type PublicHostLinkProps = {
  label: string;
  href?: string;
};

export function PublicHostLink({
  label,
  href = "/host",
}: PublicHostLinkProps) {
  return (
    <a className="public-host-link" href={href}>
      <MicVocal size={16} strokeWidth={1.8} aria-hidden="true" />
      <span>{label}</span>
    </a>
  );
}

export type HostNavigationProps = NavigationBaseProps & {
  translatorLabel: string;
  archiveLabel: string;
  translatorHref?: string;
  archiveHref?: string;
};

export function HostNavigation({
  ariaLabel,
  translatorLabel,
  archiveLabel,
  translatorHref = "/",
  archiveHref = "/host/archive",
}: HostNavigationProps) {
  return (
    <nav
      className="app-navigation app-navigation--host"
      aria-label={ariaLabel}
    >
      <a className="app-navigation__link" href={translatorHref}>
        <Languages size={17} strokeWidth={1.8} aria-hidden="true" />
        <span>{translatorLabel}</span>
      </a>
      <a className="app-navigation__link" href={archiveHref}>
        <Archive size={17} strokeWidth={1.8} aria-hidden="true" />
        <span>{archiveLabel}</span>
      </a>
    </nav>
  );
}

export type PageNavigationProps = NavigationBaseProps & {
  backLabel: string;
  backHref: string;
  homeLabel: string;
  homeHref?: string;
};

export function PageNavigation({
  ariaLabel,
  backLabel,
  backHref,
  homeLabel,
  homeHref = "/",
}: PageNavigationProps) {
  return (
    <nav
      className="app-navigation app-navigation--page"
      aria-label={ariaLabel}
    >
      <a
        className="app-navigation__link app-navigation__link--back"
        href={backHref}
      >
        <ArrowLeft size={17} strokeWidth={1.8} aria-hidden="true" />
        <span>{backLabel}</span>
      </a>
      <a
        className="app-navigation__link app-navigation__link--home"
        href={homeHref}
      >
        <Home size={17} strokeWidth={1.8} aria-hidden="true" />
        <span>{homeLabel}</span>
      </a>
    </nav>
  );
}

export type SuccessToastProps = {
  message: string;
  dismissLabel: string;
  onDismiss(): void;
  action?: {
    href: string;
    label: string;
  };
};

export function SuccessToast({
  message,
  dismissLabel,
  onDismiss,
  action,
}: SuccessToastProps) {
  return (
    <section
      className="success-toast"
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <CheckCircle2
        className="success-toast__icon"
        size={20}
        strokeWidth={1.8}
        aria-hidden="true"
      />
      <p className="success-toast__message">{message}</p>
      {action && (
        <a className="success-toast__action" href={action.href}>
          {action.label}
        </a>
      )}
      <button
        className="success-toast__dismiss"
        type="button"
        aria-label={dismissLabel}
        title={dismissLabel}
        onClick={onDismiss}
      >
        <X size={18} strokeWidth={1.8} aria-hidden="true" />
      </button>
    </section>
  );
}
